import { IconButton } from "@mui/material";
import { FC, useState } from "react";
import { Link } from "react-router-dom";
import closeMenu from "../../components/images/closeMenu.svg";
import ChangeLanguage from "../changeLanguage/ChangeLanguage";
import logo from "../images/logo_1.svg";
import menu from "../images/menu.svg";
import "./navbar.css";

type Props = {
  openMenu: boolean;
  setOpenMenu: (val: boolean) => void;
};

const NavbarTop: FC<Props> = ({ openMenu, setOpenMenu }) => {
  const [openLangBtn, setOpenLangBtn] = useState<boolean>(false);
  
  return (
    <>
      <div
        onClick={() => setOpenLangBtn(false)}
        className={
          openLangBtn ? "lang-back-container active" : "lang-back-container"
        }
      ></div>
      <div className="nav_top_container">
        <div className="nav_logo">
          <div data-aos="fade-right" data-aos-anchor-placement="top-bottom">
            <Link to="/" className="nav_logo_link">
              <img src={logo} alt="logo" />
            </Link>
          </div>
        </div>
        <div className="nav_top_info">
          <div data-aos="fade-left" data-aos-anchor-placement="top-bottom">
            <ChangeLanguage />
          </div>

          <div data-aos="fade-left" data-aos-anchor-placement="top-bottom">
            <div className="top_phone">
              <a href="tel:+998 99 229-20-20">+998 99 229-20-20</a>
            </div>
          </div>
        </div>

        <div className="nav_menu_icon_box">
          <div data-aos="fade-left">
            <IconButton
              className="icon_effect_btn"
              onClick={() => setOpenMenu(!openMenu)}
            >
              {openMenu ? (
                <img
                  src={closeMenu}
                  alt="menu"
                  onClick={() => setOpenMenu(false)}
                />
              ) : (
                <img src={menu} alt="menu" />
              )}
            </IconButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavbarTop;
